const firebaseConfigs = {
  production: {
    apiKey: 'AIzaSyBQ6o5Jkb9ep-93aryVtMpwRKVWCrer1Qc',
    authDomain: 'roitool.firebaseapp.com',
    databaseURL: 'https://roitool-default-rtdb.firebaseio.com',
    projectId: 'roitool',
    storageBucket: 'roitool.appspot.com',
    messagingSenderId: '84975679110',
    appId: '1:84975679110:web:bde0868c5467eb39a1c307',
    measurementId: 'G-1WY2N1RKDS',
  },
  dev: {
    apiKey: 'AIzaSyB_giKvoxvYkzGCT2cRixhL4mZ-ROU-ft4',
    authDomain: 'dev-roi-tool.firebaseapp.com',
    databaseURL: 'https://dev-roi-tool-default-rtdb.firebaseio.com',
    projectId: 'dev-roi-tool',
    storageBucket: 'dev-roi-tool.firebasestorage.app',
    messagingSenderId: '877083792218',
    appId: '1:877083792218:web:3539f165311d8664569963',
  },
  staging: {
    apiKey: 'AIzaSyDgfsPxqVzZR6OL5yF_q1hB9qbICdruviU',
    authDomain: 'stage-roi-tool.firebaseapp.com',
    databaseURL: 'https://stage-roi-tool-default-rtdb.firebaseio.com',
    projectId: 'stage-roi-tool',
    storageBucket: 'stage-roi-tool.firebasestorage.app',
    messagingSenderId: '1016070337876',
    appId: '1:1016070337876:web:d16822bfff380d412d04c1',
  },
  localhost: {
    apiKey: 'AIzaSyBQ6o5Jkb9ep-93aryVtMpwRKVWCrer1Qc',
    authDomain: 'roitool.firebaseapp.com',
    databaseURL: `http://127.0.0.1:${process.env.REACT_APP_DATABASE_EMULATOR_PORT || 10000}?ns=roitool`,
    projectId: 'roitool',
    storageBucket: 'roitool.appspot.com',
    messagingSenderId: '84975679110',
    appId: '1:84975679110:web:bde0868c5467eb39a1c307',
  },
};

const DEV_HOST_PATTERNS = [
  'dev-roi-tool',
  'dev.signup.bildit.co',
  'localhost',
  '127.0.0.1',
];

const STAGE_HOST_PATTERNS = [
  'stage-roi-tool',
  'stage.signup.bildit.co',
];

const PROD_HOST_PATTERNS = [
  'signup.bildit.co',
  'bildit.co',
  'roitool.web.app',
  'roitool.firebaseapp.com',
];

/** Custom signup domains → Firebase env (checked before host pattern fallbacks). */
const SIGNUP_CUSTOM_HOST_ENV = {
  'dev.signup.bildit.co': 'dev',
  'stage.signup.bildit.co': 'staging',
  'signup.bildit.co': 'production',
};

/**
 * True when the page is served from a known dev host.
 * Checked before REACT_APP_FIREBASE_ENV so a production build deployed
 * to dev-roi-tool.web.app still talks to dev-roi-tool functions.
 */
export function isDevHost() {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname;
  return DEV_HOST_PATTERNS.some((pattern) => host.includes(pattern));
}

/**
 * True when the page is served from a known staging host.
 * Checked before REACT_APP_FIREBASE_ENV so a production build deployed
 * to stage-roi-tool.web.app still talks to stage-roi-tool functions.
 */
export function isStageHost() {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname;
  return STAGE_HOST_PATTERNS.some((pattern) => host.includes(pattern));
}

/**
 * True when the page is served from a known production host.
 * Checked before REACT_APP_FIREBASE_ENV so a build accidentally produced
 * with REACT_APP_FIREBASE_ENV=dev (e.g. via `npm run build:dev`) still talks
 * to the production project when deployed to signup.bildit.co.
 */
export function isProdHost() {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname;
  return PROD_HOST_PATTERNS.some((pattern) => host === pattern);
}

/**
 * @param {string} [hostname]
 * @return {boolean}
 */
export function isLocalHostName(hostname) {
  const host =
    hostname ||
    (typeof window !== 'undefined' ? window.location.hostname : '');
  return host === 'localhost' || host === '127.0.0.1';
}

/**
 * @param {string} [hostname]
 * @return {'dev' | 'staging' | 'production' | null}
 */
export function envForSignupHost(hostname) {
  const host =
    hostname ||
    (typeof window !== 'undefined' ? window.location.hostname : '');
  return SIGNUP_CUSTOM_HOST_ENV[host] || null;
}

/**
 * @return {'dev' | 'staging' | 'production' | 'localhost'}
 */
export function resolveFirebaseEnv() {
  if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true') {
    return 'localhost';
  }

  // Browser localhost must use local emulators even if the emulator flag
  // was omitted. Skip in Jest — jsdom hostname is localhost.
  if (process.env.NODE_ENV !== 'test' && isLocalHostName()) {
    return 'localhost';
  }

  const signupHostEnv = envForSignupHost();
  if (signupHostEnv) {
    return signupHostEnv;
  }

  if (isDevHost()) {
    return 'dev';
  }

  if (isStageHost()) {
    return 'staging';
  }

  // Production hosts always use the production project, regardless of the
  // value baked into REACT_APP_FIREBASE_ENV at build time.
  if (isProdHost()) {
    return 'production';
  }

  if (process.env.REACT_APP_FIREBASE_ENV) {
    return process.env.REACT_APP_FIREBASE_ENV;
  }

  return 'production';
}

/**
 * @return {typeof firebaseConfigs.production}
 */
export function getFirebaseConfig() {
  const env = resolveFirebaseEnv();
  return firebaseConfigs[env] || firebaseConfigs.production;
}
